import { Component } from '@angular/core';
import { Course } from '../../data/models/Course';
import { LessonService } from '../../networking/services/lesson.service';
import { CourseService } from '../../networking/services/course.service';
import { CourseManagerService } from '../../networking/services/course-manager.service';
import { Lesson } from '../../data/models/Lesson';
import { TextCardComponent } from "../components/text-card/text-card.component";

import { MatButtonModule } from '@angular/material/button';
import { SharedDataService } from '../../helper/services/shared-data.service';
import { concatMap, firstValueFrom, from, Observable, tap } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { DialogService } from '../../helper/services/dialog.service';
import { LessonPictureService } from '../../networking/services/lesson-picture.service';
import { LessonPageService } from '../../networking/services/lesson-page.service';
import { Router } from '@angular/router';
import { HelperService } from '../../helper/services/helper.service';

@Component({
    selector: 'app-course-manager-dashboard',
    imports: [TextCardComponent, MatButtonModule, MatCardModule, MatIconModule],
    templateUrl: './course-manager-dashboard.component.html',
    styleUrl: './course-manager-dashboard.component.scss'
})
export class CourseManagerDashboardComponent {
  course!: Course
  lessons: Lesson[] = []

  constructor(private lessonService: LessonService, private lessonPageService: LessonPageService, private courseService: CourseService, private lessonPictureService: LessonPictureService, private courseManagerService: CourseManagerService, private sharedDataService: SharedDataService, private dialogService: DialogService, private router: Router, private helperService: HelperService) {}

  ngOnInit(): void {
    if(!this.isLoggedIn()){
      this.router.navigate(['dashboard']);
    }
    this.courseService.getCourseDetails("123e4567-e89b-12d3-a456-426614174000").subscribe((course) => { //Frühchen-Signale
      this.course = course;
    })
    this.lessonService.getLessonList("123e4567-e89b-12d3-a456-426614174000").subscribe((lessons) => {
      this.lessons = lessons;
    });
  }

  onSave = (content: string): Observable<any> => {
    return this.courseService.alterCourse(this.course.id, content).pipe(
      tap(() => {
        this.sharedDataService.toggleProgressBarOff();
      })
    );
  };

  navigateToLesson(id: string) {
    this.router.navigate(['/lesson-edit', id]);
  }

  isLoggedIn(): boolean {
    return this.helperService.isLoggedIn();
  }

  async addLesson() {
    const lessonTitle = await this.dialogService.openInputDialog();
    if (lessonTitle) {
      const lessonPictureList = await firstValueFrom(this.lessonPictureService.getLessonPictureList());
  
      this.lessonService.createLesson({
        title: lessonTitle,
        lessonPictureId: lessonPictureList[0].id,
        courseId: this.course.id
      }).pipe(
        concatMap((result) => {
          this.lessons.push(result);
  
          return from([
            this.lessonPageService.createLessonPage({ title: 'Einleitung', lessonId: result.id }),
            this.lessonPageService.createLessonPage({ title: 'Kursmaterialien', lessonId: result.id }),
            this.lessonPageService.createLessonPage({ title: 'Überleitung zur Lernaufgabe', lessonId: result.id }),
            this.lessonPageService.createLessonPage({ title: 'Lernaufgabe', lessonId: result.id }),
            this.lessonPageService.createLessonPage({ title: 'Fazit', lessonId: result.id }),
            this.lessonPageService.createLessonPage({ title: 'Abschluss', lessonId: result.id })
          ]).pipe(
            concatMap((request) => request) 
          );
        })
      ).subscribe({
        error: (error) => console.error('Failed to create lesson or pages:', error)
      });
    }
  }
}
